import React, { forwardRef } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

import { useDispatch, useSelector } from "react-redux";
import { clearSnackbar } from "store/actions/snackbarMessage";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2),
  },
}));

const MessageSnackbars = (props) => {
  const dispatch = useDispatch();

  const { successSnackbarMessage, successSnackbarOpen , errorSnackbarOpen, errorSnackbarMessage} = useSelector(
    state => state.ui
  );

  function handleClose() {
    dispatch(clearSnackbar());
  }



  return (
    <Root>
      <Snackbar open={successSnackbarOpen} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
        {successSnackbarMessage}
        </Alert>
      </Snackbar>

      <Snackbar open={errorSnackbarOpen} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          { errorSnackbarMessage }
        </Alert>
      </Snackbar>
    </Root>
  );
};

export default MessageSnackbars;
